<!---<div class="notification-push cursor-default animateOpen">
    <div class="bubble bubble-bottom-left" (click)="sbRef.dismiss()">
        <h6 class="comment-title">{{ data }}</h6>
            <p class="comment-content"></p>
    </div>
</div>--->

<div (click)="sbRef.dismiss()">
    <div class="row">
        <!--<div class="col-">
            <div class="color-line"></div>
        </div>-->
        <div class="col cursor-pointer" (click)="navigate(webpush.link)">
            <h6 class="notification-title" style="margin-bottom:2px;">{{ webpush.notificationtitle }}</h6>
            <p class="notification-desc"><quill-view-html class="viewer notification-desc" [content]="webpush.notificationdescription" theme="snow"></quill-view-html></p>    
        </div>
    </div>
   
</div>
